import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'product-takeoff-deatail-section',
  imports: [CommonModule],
  templateUrl: './product-detail-section.component.html'
})
export class ProductDetailSectionComponent {
  productCode = input<string>('');
  productName = input<string>('');
  setupProductClick = output<void>();
}
